import jsPDF from "jspdf";
import "jspdf-autotable";
import copy from "copy-to-clipboard";
import es from "../translate/es.json";
import en from "../translate/en.json";
import pt from "../translate/pt.json";
import XLSX from "xlsx";
import { FaClock, FaCheck, FaTimes, FaTimesCircle, FaRegClock, FaRegBuilding, FaBoxOpen, FaDoorOpen, FaBox, FaCheckCircle, FaUndo, FaTruck } from "react-icons/fa";
import { TfiReload } from "react-icons/tfi";
import { TbFlag3 } from "react-icons/tb";
import { AiOutlineFileAdd, AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineCheckCircle, AiOutlineUser } from "react-icons/ai";
import { IoLockClosedOutline } from "react-icons/io5";
import { FaCircleCheck } from "react-icons/fa6";
import { BiPackage } from "react-icons/bi";
import { PiLockers, PiLockersFill } from "react-icons/pi";
import { saveAs } from 'file-saver';

//  ------- > GETTERS
export const getUser = () => {
  const userStr = sessionStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

export const getToken = () => {
  return sessionStorage.getItem("token") || null;
};

export const getClientDomain = (version) => {
  let domainV1 = "";
  let domainV2 = "";

  if (version === 2) return sessionStorage.getItem("apDomainV2") || domainV2;

  return sessionStorage.getItem("apDomain") || domainV1;
};

export const getClDomain = () => {
  return sessionStorage.getItem("clDomain") || null;
};

/**
 * Returns the environment label for the current hostname.
 * localhost / dev → DEV, staging → STAGING, prod → LIVE.
 */
export const getEnvironmentLabel = () => {
  if (typeof window === "undefined") return "DEV";
  const host = (window.location.hostname || "").toLowerCase();
  if (host === "bli.myboxit.com") return "LIVE";
  if (host === "staging-bli.myboxit.com") return "STAGING";
  if (host === "dev-bli.myboxit.com" || host === "localhost" || host === "127.0.0.1") return "DEV";
  return "DEV";
};

export const getNavigationPage = () => {
  return sessionStorage.getItem("currentNavPage") || null;
};

export const getPage = () => {
  return sessionStorage.getItem("currentPage") || null;
};

export const getValueSearchFilter = () => {
  return sessionStorage.getItem("valueSearchFilter" || null);
};

export const getAvaliblePlatforms = (value) => {
  const platformStr = sessionStorage.getItem("platforms");
  if (platformStr) return JSON.parse(platformStr);
  else return null;
};

export const getClasificacion = (dimension) => {
  switch (dimension) {
    case "A": case "S": case "A (EXT.) - (WIDTH X HEIGTH X LENGTH) 50 X 48 X 16 CM":
      return "P";
    case "B": case "M": case "B (EXT.) - (WIDTH X HEIGTH X LENGTH) 50 X 48 X 33 CM":
      return "M";
    case "C": case "L": case "C (EXT.) - (WIDTH X HEIGTH X LENGTH) 50 X 48 X 50 CM":
      return "G";
    case "D": case "XL":
      return "XG";
    default:
      break;
  }
};

//  ------- > SETTERS
export const setAvaliblePlatforms = (value) => {
  sessionStorage.setItem("platforms", JSON.stringify(value));
};

export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};

export const setUserSession = (token, user) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("user", JSON.stringify(user));
};


const countryAPIs = {
  pa: {
    prod: {
      apDomain: "https://api.myboxit.com/api/v1",
      apDomainV2: "https://api.myboxit.com/v2"
    },
    dev: {
      apDomain: "https://dev-api.myboxit.com/api/v1",
      apDomainV2: "https://dev-api.myboxit.com/v2",
    },
    localhost: {
      apDomain: "http://localhost:5000/api/v1",
     apDomainV2: "http://localhost:5000/v2"
    },
    // `npm start` only: relative paths served by the dev-server proxy declared
    // in craco.config.js, which forwards to the dev API. See the note below.
    "dev-proxy": {
      apDomain: "/api-pa/api/v1",
      apDomainV2: "/api-pa/v2",
    },
    // The API you are running on localhost, reached through the same dev-server
    // proxy. Both APIs listen on 5001, so whichever one is up answers.
    "local-proxy": {
      apDomain: "/api-local/api/v1",
      apDomainV2: "/api-local/v2",
    },
  },
  br: {
    prod: {
      apDomain: "https://d1dbb425nzoz86.cloudfront.net/api/v1",
      apDomainV2: "https://d1dbb425nzoz86.cloudfront.net/v2",
    },
    dev: {
      apDomain: "https://dev-api.myboxit.com.br/api/v1",
      apDomainV2: "https://dev-api.myboxit.com.br/v2",
    },
    localhost: {
      apDomain: "http://localhost:5001/api/v1",
      apDomainV2: "http://localhost:5001/v2",
    },
    "dev-proxy": {
      apDomain: "/api-br/api/v1",
      apDomainV2: "/api-br/v2",
    },
    // The API you are running on localhost, reached through the same dev-server
    // proxy. Both APIs listen on 5001, so whichever one is up answers.
    "local-proxy": {
      apDomain: "/api-local/api/v1",
      apDomainV2: "/api-local/v2",
    },
  },
  us: {
    prod: {
      apDomain: "https://api-golocker.myboxit.com/api/v1",
      apDomainV2: "https://api-golocker.myboxit.com/v2",
    },
    dev: {
      apDomain: "https://dev-api-golocker.myboxit.com/api/v1",
      apDomainV2: "https://dev-api-golocker.myboxit.com/v2",
    },
    staging: {
      apDomain: "https://staging-api-golocker.myboxit.com/api/v1",
      apDomainV2: "https://staging-api-golocker.myboxit.com/v2",
    },
    localhost: {
      apDomain: "http://localhost:5003/api/v1",
      apDomainV2: "http://localhost:5003/v2",
    },
    "dev-proxy": {
      apDomain: "/api-us/api/v1",
      apDomainV2: "/api-us/v2",
    },
    // The API you are running on localhost, reached through the same dev-server
    // proxy. Both APIs listen on 5001, so whichever one is up answers.
    "local-proxy": {
      apDomain: "/api-local/api/v1",
      apDomainV2: "/api-local/v2",
    },
  },
};

/**
 * Local override so `npm start` can talk to a deployed API instead of the
 * localhost backends, which otherwise have to be running for the app to do
 * anything. Set in .env.local (gitignored, so it never affects other machines
 * or the deployed build):
 *
 *   REACT_APP_API_ENV=dev-proxy      # dev-proxy | local-proxy | dev | staging | prod
 *   REACT_APP_API_DOMAIN=...         # or pin both URLs explicitly
 *   REACT_APP_API_DOMAIN_V2=...
 *
 * `dev-proxy` is the one to use for `npm start`. It resolves to relative paths
 * that the dev-server proxy forwards to the dev API of the selected country,
 * so the request leaves the browser same-origin and CORS never enters the
 * picture. It matters: the PA dev API (dev-api.myboxit.com) does not send
 * `Access-Control-Allow-Origin` for localhost, so `dev` cannot reach it from a
 * local frontend at all, while the US one (dev-api-golocker.myboxit.com) can.
 * Switching country in the login screen keeps working, because the country is
 * still what picks the entry.
 *
 * Returns the {apDomain, apDomainV2} pair to use, or null to fall back to the
 * hostname rules below.
 */
const resolveApiOverride = (config) => {
  const apDomain = process.env.REACT_APP_API_DOMAIN;
  const apDomainV2 = process.env.REACT_APP_API_DOMAIN_V2;
  if (apDomain && apDomainV2) return { apDomain, apDomainV2 };

  const envName = process.env.REACT_APP_API_ENV;
  if (envName && config[envName]) return config[envName];

  return null;
};

/** Dispatched after the selected country changes, so screens can re-read it. */
export const COUNTRY_CHANGED_EVENT = "boxit-country-changed";

export const setClientDomain = (location) => {
  sessionStorage.setItem("clDomain", location);
  const country = localStorage.getItem("country") || "pa";
  const config = countryAPIs[country];

  const override = resolveApiOverride(config);
  if (override) {
    sessionStorage.setItem("apDomain", override.apDomain);
    sessionStorage.setItem("apDomainV2", override.apDomainV2);
    return;
  }

  if (location === "bli.myboxit.com"){
    sessionStorage.setItem("apDomain", config.prod.apDomain);
    sessionStorage.setItem("apDomainV2", config.prod.apDomainV2);
  }else if(location === "dev-bli.myboxit.com"){
    sessionStorage.setItem("apDomain", config.dev.apDomain);
    sessionStorage.setItem("apDomainV2", config.dev.apDomainV2);
  }else if(location === "staging-bli.myboxit.com" && config.staging){
    sessionStorage.setItem("apDomain", config.staging.apDomain);
    sessionStorage.setItem("apDomainV2", config.staging.apDomainV2);
  }else{
    sessionStorage.setItem("apDomain", config.localhost.apDomain);
    sessionStorage.setItem("apDomainV2", config.localhost.apDomainV2);
  }

};

export const setNavigationPage = (value) => {
  sessionStorage.setItem("currentNavPage", value);
};

export const setPage = (value) => {
  sessionStorage.setItem("currentPage", value);
};

export const setValueSearchFilter = (value) => {
  sessionStorage.setItem("valueSearchFilter", value);
};

//  ------- > OTHER METHODS
export const round = (value, decimals) => {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

export const checkConnectionStatus = () => navigator.onLine;

export const exportToPDF = (nombreReporte, filename, reportCol, reportRows, titleFile) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "px",
    format: "a4",
  });

  let logoBoxit = new Image();
  logoBoxit.src = "/img/logo-boxit.png";
  doc.addImage(logoBoxit, "PNG", 340, 20, 80, 30);
  const fecha = new Date();

  doc.setFont("Helvetica", "bold");
  doc.setFontSize(25);
  doc.text("Boxit Logística Inteligente", 40, 40);
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()}/${
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    }/${fecha.getFullYear()} ${
      fecha.getHours() <= 12 ? fecha.getHours() : fecha.getHours() - 12
    }:${
      fecha.getMinutes() < 10 ? `0${fecha.getMinutes()}` : fecha.getMinutes()
    } ${fecha.getHours() < 12 ? "AM" : "PM"}`,
    40,
    50
  );
  doc.text(
    `${translate("global.exportPDF.madeBy")}: ${getUser().NombreSimple} ${getUser().ApellidoSimple}`,
    40,
    65
  );
  doc.text(`${translate("global.report")}: ${nombreReporte}`, 40, 75);

  // Centrado del título
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(13);

  const pageWidth = doc.internal.pageSize.getWidth();  // Obtener el ancho de la página
  const titleWidth = doc.getTextWidth(titleFile);      // Obtener el ancho del texto
  const xPos = (pageWidth - titleWidth) / 2;           // Calcular la posición X para centrar el texto

  doc.text(titleFile, xPos, 100);  // Utiliza xPos para centrar el texto horizontalmente

  doc.autoTable({
    startY: 110,
    styles: { fontSize: 8 },
    columns: reportCol,
    body: reportRows,
  });

  doc.save(
    `${filename} ${
      fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
    }-${
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    }-${fecha.getFullYear()}`
  );
};

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const statusDeliveryOrderFormat = (IdEstatus) => {
  switch (IdEstatus) {
    case 1:
      return "text-primary";
    case 2:
      return "text-info";
    case 5:
      return "text-warning";
    case 4:
      return "text-success";
    case 3:
      return "text-danger";
    case 6:
      return "text-danger";
    case 7:
      return "text-warning";
    default:
      break;
  }
};

export const handleMonth = (month, type = 'S') => {
  const months = {
    short: {
      1: "common.short_months.january",
      2: "common.short_months.february",
      3: "common.short_months.march",
      4: "common.short_months.april",
      5: "common.short_months.may",
      6: "common.short_months.june",
      7: "common.short_months.july",
      8: "common.short_months.august",
      9: "common.short_months.september",
      10: "common.short_months.october",
      11: "common.short_months.november",
      12: "common.short_months.december",
    },
    long: {
      1: "common.full_months.january",
      2: "common.full_months.february",
      3: "common.full_months.march",
      4: "common.full_months.april",
      5: "common.full_months.may",
      6: "common.full_months.june",
      7: "common.full_months.july",
      8: "common.full_months.august",
      9: "common.full_months.september",
      10: "common.full_months.october",
      11: "common.full_months.november",
      12: "common.full_months.december",
    },
  };

  // Convertir el mes a número si es una cadena
  const monthNumber = typeof month === 'string' ? parseInt(month, 10) : month;

  // Determinar el tipo de formato (short o long)
  const monthType = type === 'L' ? 'long' : 'short';

  // Obtener la clave de traducción
  const translationKey = months[monthType][monthNumber];

  // Devolver la traducción o un mensaje de error si el mes no es válido
  return translationKey ? translate(translationKey) : "Invalid Month";
};

export const scrollTo = (value) =>
  document.getElementById("mainLayout").scrollTo({
    top: value,
    behavior: "smooth",
  });

export const copyToClipboard = (value) => copy(value);

/**
 * Explicación de los parámetros:
 * 
 * - key: (string) La clave de traducción que se usará para buscar el texto traducido en los diccionarios de idiomas.
 * - caseType: (string, opcional) Define el formato de mayúsculas/minúsculas que se aplicará al texto traducido.
 *      - 'none' (por defecto): No modifica el texto.
 *      - 'upper': Convierte todo el texto a mayúsculas.
 *      - 'lower': Convierte todo el texto a minúsculas.
 *      - 'capital': Convierte solo la primera letra a mayúscula y el resto a minúsculas.
 * 
 */

export const translate = (key, caseType = 'none') => {
  const lang = window.navigator.language?.split("-")[0];
  let langStorage = localStorage.getItem("language");
  let language = null;

  if (langStorage == null) {
    localStorage.setItem("language", lang);
    language = localStorage.getItem("language");
  } else {
    language = langStorage;
  }

  let translatedText = '';

  switch (language) {
    case "es":
      translatedText = es[key];
      break;
    case "pt":
      translatedText = pt[key];
      break;
    default:
      translatedText = en[key];
  }

  // Modificación de la palabra según el caso proporcionado
  switch (caseType) {
    case 'upper':
      return translatedText.toUpperCase();
    case 'lower':
      return translatedText.toLowerCase();
    case 'capital':
      return translatedText.charAt(0).toUpperCase() + translatedText.slice(1).toLowerCase();
    default:
      return translatedText;
  }

};

export const getCountryCodeFromCoordinates = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    const data = await response.json();
    const country = data.address.country_code;
    if (country) {
      return country;
    } else {
      console.log("Location not found.");
    }
  } catch (error) {
    console.error("Error fetching location:", error);
  }
};

export const getNameStatus = (id) => {
  switch (id) {
    case 1:
      return translate("global.status.new");
    case 2:
      return translate("global.status.processed");
    case 3:
      return translate("global.status.returned");
    case 4:
      return translate("global.status.completed");
    case 5:
      return translate("global.status.inTransit");
    case 6:
      return translate("global.status.canceled");
    default:
      break;
  }
};


export const getFormatDate = (date, time = false) => {
  let processedDate = date;
  
  if (time) {
    // Crear un objeto Date a partir del string original
    const originalDate = new Date(processedDate);
    // Restar 5 horas (18000000 milisegundos)
    originalDate.setTime(originalDate.getTime() - (5 * 60 * 60 * 1000));
    
    // Formatear la nueva fecha a ISO string y reemplazar processedDate
    processedDate = originalDate.toISOString();
  }

  const year = processedDate.substring(0, 4);
  const month = processedDate.substring(5, 7);
  const day = processedDate.substring(8, 10);

  if (time) {    
    // Extraer hora y minutos del string ya ajustado
    const hour24 = processedDate.substring(11, 13);  // Hora en formato 24h
    const minute = processedDate.substring(14, 16);  // Minutos

    return `${day} ${getNameMonth(month)} ${year} ${hour24}:${minute}`;
  }

  return `${day} ${getNameMonth(month)} ${year}`;
};

export const getFormatDateInput = (date) => {
  return date ? date.split('T')[0] : "" ;
}

export const getNameGender = (gender) => {
  switch (gender) {
    case "M":
      return translate("global.female")
    case "H":
      return translate("global.male")
    default:
      break;
}

}

export const getFormatDateHour = (date) => {

  // Crear un objeto Date a partir de la cadena de fecha
  const fecha = new Date(date);

  // Obtener la hora y los minutos
  const hora = fecha.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    hour12: false,
  });
  const minutos = fecha.getMinutes();

  return `Hora: ${hora}, Minutos: ${minutos}`;
};

export const getNameMonth = (month) => {
  const monthFormat = Number(month);

  const monthMap = {
    1: "common.full_months.january",
    2: "common.full_months.february",
    3: "common.full_months.march",
    4: "common.full_months.april",
    5: "common.full_months.may",
    6: "common.full_months.june",
    7: "common.full_months.july",
    8: "common.full_months.august",
    9: "common.full_months.september",
    10: "common.full_months.october",
    11: "common.full_months.november",
    12: "common.full_months.december",
  };

  const monthName = monthMap[monthFormat] || "Invalid Month";
  return translate(monthName);
};

export const generateResponse = (result) => {
  const codeToMessageMap = {
    200: {key : "login.activate.USER_WAS_ACTIVATED_SUCCESSFULLY", icon: true},
    404: {key : "login.activate.USER_NOT_FOUND", icon: false},
    400: {key : "login.activate.USER_IS_ALREADY_ACTIVE", icon: true},
    401: {key : "login.activate.UNAUTHORIZED_USER", icon: false},
    500: {key : "login.forgotpwd.validate.errorServer", icon: false},
  };

  const code = result.code || 500;
  const messageKey = codeToMessageMap[code].key;
  const iconValue = codeToMessageMap[code].icon;

  return {
    code: code,
    message: translate(messageKey) || result.message,
    icon: iconValue
  };
};

export const formatDatePicker = (date, type) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return type ? `${day}/${month}/${year}` : `${year}-${month}-${day}`;
};

export const generateExcelAccounting = (data) => {
  const headers = Object.keys(data[0]);
  const dataArray = data.map((item) => Object.values(item));
  dataArray.unshift(headers);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(dataArray);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, "Accounting.xlsx");
};

export const generateExcelFile = (data, name) => {
  const headers = Object.keys(data[0]);
  const dataArray = data.map((item) => Object.values(item));
  dataArray.unshift(headers);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(dataArray);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${name}.xlsx`);
};

export const formatNumDecimal = (num) => {
  return num.toFixed(2);
};

export const getAllMonths = () => {
  return [
    translate("common.full_months.january"),
    translate("common.full_months.february"),
    translate("common.full_months.march"),
    translate("common.full_months.april"),
    translate("common.full_months.may"),
    translate("common.full_months.june"),
    translate("common.full_months.july"),
    translate("common.full_months.august"),
    translate("common.full_months.september"),
    translate("common.full_months.october"),
    translate("common.full_months.november"),
    translate("common.full_months.december"),
  ];
};

export const areMoreThan3Months = (dateFrom, dateTo) => {
  const monthsDifference =
    (dateTo.getFullYear() - dateFrom.getFullYear()) * 12 +
    dateTo.getMonth() -
    dateFrom.getMonth();

  return monthsDifference > 3;
};

export const parseExcel = (file) => {
  const columnKeys = [];
  file.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (!columnKeys.includes(key?.toUpperCase()))
        columnKeys.push(key?.toUpperCase());
    });
  });

  const rows = file.map((row) =>
    columnKeys.map((key) =>
      row[key] !== undefined && row[key] !== null ? row[key] : "-"
    )
  );
  const cols = columnKeys.map((name, index) => ({
    name: String.fromCharCode(65 + index),
    key: index,
  }));

  const result = {
    rows: [columnKeys, ...rows],
    cols: cols,
  };

  return result;
};

const statusPackages = {
  1: "new",
  2: "reservedDoor",
  3: "inBoxit",
  4: "retired",
  5: "returned",
  6: "annulled",
  7: "inTransit",
};
//status paquetes alertados
const statusPackagesAlerted = {
  3: "alerted",
  4: "inOffice",
  5: "cancelled",
};

const statusTypesPackages = {
  2: "regular",
  3: "returned",
};

export const setStatusObjTranslate = (obj) => {
  for (let i = 0; i < obj.length; i++) {
    const idEstatus = obj[i].IdEstatus;
    obj[i].EstatusBoxit = setStatusName(idEstatus);
  }
  return obj;
};

export const setStatusAlertedObjTranslate = (obj) => {
  for (let i = 0; i < obj.length; i++) {
    const idEstatus = obj[i].IdEstatus;
    obj[i].EstatusAlerted = setStatusAlerted(idEstatus);
  }
  return obj;
};

export const setStatusName = (id) => {
  let response = `global.status.${statusPackages[id]}`;
  return translate(response);
};

export const setStatusAlerted = (id) => {
  let response = `global.status.package.${statusPackagesAlerted[id]}`;
  return translate(response);
};

export const setStatusTypePackageName = (id) => {
  let response = `global.status.typePackage.${statusTypesPackages[id]}`;
  return translate(response);
};

export const handlerColorPackagesEstatus = value => {
  switch (value) {
      case 1:
          return 'text-warning';
      case 2:
          return 'text-info';
      case 3:
          return 'text-warning';
      case 4:
          return 'text-success';
      case 5:
          return 'text-danger';
      case 6:
          return 'text-danger'
      default:
          break;
  }
}

export const removeAccents = (str) => {
  return str
    .normalize("NFD") // Normaliza la cadena (quita los acentos)
    .replace(/[\u0300-\u036f]/g, ""); // Elimina los caracteres diacríticos
};

export const convertCoordinatesToArrayWithLatAndLng = (locations) => {
  const newArray = JSON.parse(JSON.stringify(locations));

  newArray.forEach((location, index) => {
    if (typeof location.coordinates === "string") {
      const coordinates = location.coordinates.split(",");
      const lat = parseFloat(coordinates[0]);
      const lng = parseFloat(coordinates[1]);

      // Validar si ambos valores son números válidos
      if (!isNaN(lat) && !isNaN(lng)) {
        location.lat = lat;
        location.lng = lng;
      } else {
        console.warn(`Coordenadas inválidas en el índice ${index}:`, location.coordinates);
        location.lat = null;
        location.lng = null;
      }
    } else {
      console.warn(`Campo coordinates no es una cadena en el índice ${index}:`, location);
      location.lat = null;
      location.lng = null;
    }

    delete location.coordinates;
  });

  return newArray;
};

export function formatFileSize(sizeInBytes) {
  if (sizeInBytes < 1024) {
    return sizeInBytes + " bytes";
  } else if (sizeInBytes < 1024 * 1024) {
    return (sizeInBytes / 1024).toFixed(2) + " KB";
  } else if (sizeInBytes < 1024 * 1024 * 1024) {
    return (sizeInBytes / (1024 * 1024)).toFixed(2) + " MB";
  } else {
    return (sizeInBytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
  }
}

export function formatFileType(mimeType) {
  const parts = mimeType.split("/");
  if (parts.length === 2) {
    return parts[1];
  } else {
    return null;
  }
}

export function viewImageTypeBuffer(file, type) {
  if (type) {
    const base64Image = Buffer.from(file.data).toString("base64");
    const fileNext = `data:${type};base64,${base64Image}`;

    return fileNext;
  }
}

export function formatMoneyString(amount) {
  return parseFloat(amount).toFixed(2);
}

export function calculatePercentage(value, total) {
  value = parseFloat(value);
  total = parseFloat(total);

  if (isNaN(value) || isNaN(total) || total === 0) {
    return 0;
  }

  const percentage = (value / total) * 100;
  return `${Math.round(percentage)}%`;
}

export function getMonthsBilling() {
  const currentDate = new Date();
  const previousMonths = [];

  for (let i = 0; i < 3; i++) {
    let month = currentDate.getMonth() - i;
    let year = currentDate.getFullYear();

    if (month < 0) {
      month += 12;
      year -= 1;
    }

    previousMonths.push({
      month: (month + 1).toString().padStart(2, "0"),
      year: year.toString(),
      monthName: getNameMonth((month + 1).toString().padStart(2, "0")),
    });
  }

  return previousMonths;
}

const typePlans = {
  1: "Enterprise",
  2: "Business",
  3: "Basic",
};

export const getTypePlan = (id) => {
  return typePlans[id];
};

export const typeStatus = [
  {
    id: 1,
    text: translate("global.pending"),
    color: "#ffb400",
    background: "rgba(238, 143, 0, 0.1)",
    icon: <FaClock />,
    action: true,
  },
  {
    id: 2,
    text: translate("global.inProgress"),
    color: "#0099C9",
    background: "rgba(0, 153, 201, 0.1)",
    icon: <TfiReload />,
    actionAdmin: true,
  },
  {
    id: 3,
    text: translate("global.completed"),
    color: "#218E06",
    background: "rgba(33, 142, 6, 0.1)",
    icon: <FaCheck />,
    infoText: true,
  },
  {
    id: 4,
    text: translate("global.declined"),
    color: "#C86160",
    background: "rgba(200, 97, 96, 0.1)",
    icon: <FaTimes />,
    action: true,
    infoText: true,
  },
];

export const getStatusText = (status) => {
  const statusNumber = parseInt(status);
  const index = statusNumber - 1;

  if (index >= 0 && index < typeStatus.length) {
    return typeStatus[index];
  } else {
    // Handle invalid status values or out-of-range indices
    console.error(`Invalid status value: ${status}`);
    return null; // Or return a default status object
  }
};

export const getDateSeparate = (inputDate) => {
  const dateParts = inputDate.split("-");

  const result = {
    day: dateParts[2],
    month: dateParts[1],
    year: dateParts[0],
  };

  return result;
};

export const formatTransactionMonthly = (data) => {
  if (data && data.length > 0) {
    // Realizar el mapeo y crear el formato de factura mensual
    const transactionMonthlyFormat = data.map((item) => {
      return {
        [translate("global.nroIdentific")]: item.NumeroIdentificacion,
        [translate("global.Amount")]: formatter.format(item.Monto),
        [translate("global.dateDropOff")]: item.FechaEntrega,
        [translate("global.datePickup")]: item.FechaRetiro,
        [translate("global.email")]: item.EmailCliente,
        Locker: item.Locker,
      };
    });

    return transactionMonthlyFormat;
  } else {
    return {};
  }
};

export const formatListAdminBilling = (data) => {
  if (data && data.length > 0) {
    const response = data.map((item) => {
      return {
        ...item,
        IdEstatus: getStatusText(item.IdEstatus).text,
      };
    });

    return response;
  } else {
    return {};
  }
};

export const sqlDateFormat = (date, type) => {
  const newDate = new Date(date).toLocaleString("en-US").replace(",", "");
  if (type) {
    const sqlDate = new Date(date);
    return `${sqlDate.getFullYear()}-${(sqlDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${sqlDate
      .getDate()
      .toString()
      .padStart(2, "0")} ${sqlDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${sqlDate
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${sqlDate.getSeconds().toString().padStart(2, "0")}`;
  }

  return newDate;
};

export const countIdStatus = (array) => {
  let count = {};
  typeStatus.forEach((status) => {
    count[status.id] = 0;
  });

  array.forEach((item) => {
    let idStatus = item.IdEstatus;
    if (count[idStatus] !== undefined) {
      count[idStatus]++;
    }
  });

  return count;
};

export const rangeYears = (start, end, step) => {
  const result = [];
  for (let i = start; i < end; i += step) {
    result.push(i);
  }
  return result;
};

export function getNameImage(data) {
  const parts = data.split("/");
  const fileName = parts[parts.length - 1];
  const match = fileName.match(/(.+)\.([a-zA-Z0-9]+)$/);

  return {
    name: fileName,
    type: match[2],
  };
}

export const statusOnline = (
  <div className="lx yz zd aac cbl">
    <div className="axw ajg uo ads aqm">
      <div className="ne rf ads ahy"></div>
    </div>
    <div className="md bah bxo"></div>
  </div>
);

export const statusOffline = (
  <div className="lx yz zd aac cbl">
    <div className="azi akr uo ads aqm">
      <div className="ne rf ads ahy"></div>
    </div>
    <div className="md bah bxo"></div>
  </div>
);

export const statusBusyDoor = (
  <div className="lx yz zd aac cbl">
  <div className="axw-yellow ajg-yellow uo ads aqm">
    <div className="ne rf ads ahy"></div>
  </div>
  <div className="md bah bxo"></div>
</div>
);

export const statusReservedDoor = (
  <div className="lx yz zd aac cbl">
    <div className="axw-online ajg-online uo ads aqm">
      <div className="ne rf ads ahy"></div>
    </div>
    <div className="md bah bxo"></div>
  </div>
);

export const statusExpiredDoor = (
  <div className="lx yz zd aac cbl">
  <div className="azi-offline akr-offline uo ads aqm">
    <div className="ne rf ads ahy"></div>
  </div>
  <div className="md bah bxo"></div>
</div>
);

export function verifyHideCountry() {
  var country = localStorage.getItem('country');

  if (country && (country.toLowerCase() === 'br' || country.toLowerCase() === 'us')) {
    return false;
  } else {
    return true;
  }
}

export function verifyHideCountry2() {
  var country = localStorage.getItem('country');

  if (country && (country.toLowerCase() === 'pa' || country.toLowerCase() === 'us')) {
    return false;
  } else {
    return true;
  }
}

export function verifyHideCountryItems(countryToHide) {
  var country = localStorage.getItem('country');

  if (country && Array.isArray(countryToHide) && countryToHide.map(c => c.toLowerCase()).includes(country.toLowerCase())) {
    return false; 
  } else {
    return true;
  }
}

export const getAvalibleTypesIncidents = (value) => {
  const result = sessionStorage.getItem("types-incidents");
  if (result) return JSON.parse(result);
  else return null;
};

export const setAvalibleTypesIncidents = (value) => {
  sessionStorage.setItem("types-incidents", JSON.stringify(value));
};

export const getAvaliblePriorityIncidents = (value) => {
  const result = sessionStorage.getItem("priority-incidents");
  if (result) return JSON.parse(result);
  else return null;
};

export const setAvaliblePriorityIncidents = (value) => {
  sessionStorage.setItem("priority-incidents", JSON.stringify(value));
};

export const getAvalibleStatusIncidents = (value) => {
  const result = sessionStorage.getItem("status-incidents");
  if (result) return JSON.parse(result);
  else return null;
};

export const setAvalibleStatusIncidents = (value) => {
  sessionStorage.setItem("status-incidents", JSON.stringify(value));
};

const incidentsVariables = {
  types:{
    1: "global.incidents.type.lockerApp",
    2: "global.incidents.type.hardware",
    3: "global.incidents.type.internet",
    4: "global.incidents.type.door",
    5: "global.incidents.type.payment",
    6: "global.incidents.type.package",
    7: "global.incidents.type.automaticIncident",
    8: "global.incidents.type.other",
    9: "global.incidents.type.dashboard",
    10: "global.incidents.type.customerAccount",
    11: "global.incidents.type.generalInquiry",
    12: "global.incidents.type.facilityIssue",
    13: "global.incidents.type.billingIssue",
    14: "global.incidents.type.oversizedPackage",
    15: "global.incidents.type.expiredPackage",
    16: "global.incidents.type.qrCodeOrPinCodeIssue",
    17: "global.incidents.type.missingPackage",
    18: "global.incidents.type.mislabeledOrDamagedPackage",
    19: "global.incidents.type.packageDeliveredToLocker",
    20: "global.incidents.type.returnFlowPackage",
    21: "global.incidents.type.holdPackageAtWarehouse",
    22: "global.incidents.type.misroutedPackageOldAddress",
    23: "global.incidents.type.packageWithNoLabel",
    24: "global.incidents.type.expirationDateExtension",
    25: "global.incidents.type.misroutedPackageBNY",
    26: "global.incidents.type.packageNoDeliveryXADABUG",
    27: "global.incidents.type.latePackageDelivery",
    28: "global.incidents.type.reservedPackagePendingDelivery",
    29: "global.incidents.type.misdeliveredPackageAnotherCustomer",
    30: "global.incidents.type.pudoCase",
    31: "global.incidents.type.packageLostByShipper",
    32: "global.incidents.type.packageDeliveredIncorrectWarehouseArea",
    33: "global.incidents.type.packageDeliveredOccupiedDoor"
  },
  priority: {
    1: "global.incidents.priority.high",
    2: "global.incidents.priority.medium",
    3: "global.incidents.priority.low"
  },
  status: {
    1: "global.incidents.status.new",
    2: "global.incidents.status.onHold",
    3: "global.incidents.status.inProcess",
    4: "global.incidents.status.solved",
    5: "global.incidents.status.closed",
    6: "global.incidents.status.canceled",
    7: "global.incidents.status.asigned",
  },
  origins: {
    1: "global.incidents.origin.call",
    2: "global.incidents.origin.email",
    3: "global.incidents.origin.sms",
    4: "global.incidents.origin.system",
    5: "global.incidents.origin.whatsapp",
    6: "global.incidents.origin.crm",
    7: "global.incidents.origin.other",
  }
};

const doorsVariables = {
  movements:{
    1: "global.movementsTypes.delivery",
    2: "global.movementsTypes.pickupClient",
    8: "global.movementsTypes.packExpiredCollected"
  }
};

export const getNameIncidentsTypes = (id) => {
  return incidentsVariables.types[id] ? translate(incidentsVariables.types[id]) : "";
};

export const getNameIncidentsPriority = (id) => {
  return incidentsVariables.priority[id] ? translate(incidentsVariables.priority[id]) : "";
};

export const getNameIncidentsStatus = (id) => {
  return incidentsVariables.status[id] ? translate(incidentsVariables.status[id]) : "";
};

export const getNameIncidentsOrigins = (id) => {
  return incidentsVariables.origins[id] ? translate(incidentsVariables.origins[id]) : "";
};

export const getNameUserSupport = (userId) => {
  if (!userId) return undefined;

  const assignedUsers = handleStorage('get', 'session', 'users-support');

  if (!Array.isArray(assignedUsers)) return undefined;

  const found = assignedUsers.find(u => String(u.value) === String(userId));

  return found?.label;
};

export const getNameClient = (clientId) => {
  if (!clientId) return undefined;

  // Buscar en localStorage directamente (donde ClientsSearchList guarda los clientes)
  const clientsCache = localStorage.getItem('clients-cache');
  let clients = [];
  
  try {
    clients = clientsCache ? JSON.parse(clientsCache) : [];
  } catch (error) {
    console.error('Error parsing clients cache:', error);
    clients = [];
  }

  if (!Array.isArray(clients)) return `ID: ${clientId}`;

  const found = clients.find(c => String(c.value) === String(clientId));

  // Si encontramos el cliente y tiene fullName, lo usamos, sino usamos el label completo
  if (found?.fullName) {
    return `${found.value} - ${found.fullName}`;
  } else if (found?.label) {
    return found.label;
  }

  return `ID: ${clientId}`;
};

export const getNamePlatform = (platformId) => {
  if (!platformId) return undefined;

  const platforms = getAvaliblePlatforms();

  if (!Array.isArray(platforms)) return `ID: ${platformId}`;

  const found = platforms.find(p => String(p.boxitLocationId) === String(platformId));

  if (found?.locationName) {
    return found.locationName;
  }

  return `ID: ${platformId}`;
};

export const getNameDoorsMovements = (id) => {
  return doorsVariables.movements[id] ? translate(doorsVariables.movements[id])?.toUpperCase() : "";
};


export const todayDate = new Date();
export const firstDayOfMonth = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
const lastDayOfMonth = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);

export const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

export const defaultFilterIncidents = {
  typeIncident: [],
  priorityIncident: [],
  statusIncident: [1, 2, 3],
  startDate: [],
  endDate: [],
  assignedUser: [],
  clientId: [],
  platformId: [],
  incidentId: []
};

export  const getFlagPriorityIncident = (priorityId) => {
  switch (priorityId) {
    case 1:
      return <TbFlag3 style={{ color: "red" }} size={20}/>;
    case 2:
      return <TbFlag3 style={{ color: "#FFA500" }} size={20} />;
    case 3:
      return <TbFlag3 style={{ color: "blue" }} size={20}/>;
    default:
      return null;
  }
};

export  const getColorPriorityIncident = (priorityId) => {
  switch (priorityId) {
    case 1:
      return "danger";
    case 2:
      return "warning";
    case 3:
      return "primary" ;
    default:
      return null;
  }
};

export  const getIconStatusIncident = (id) => {
  switch (id) {
    case 1:
      return <AiOutlineFileAdd />;
    case 2:
      return <AiOutlineClockCircle />;
    case 3:
      return <TfiReload />;
      case 4:
        return <AiOutlineCheckCircle />;
      case 5:
        return <IoLockClosedOutline /> ;
        case 6:
          return <AiOutlineCloseCircle />;
        case 7:
          return <AiOutlineUser />;
    default:
      return null;
  }
};

export  const getColorStatusIncident = (id) => {
  switch (id) {
    case 1:
      return "bg-blue-500";
    case 2:
      return "bg-yellow-500";
    case 3:
      return "bg-orange-500";
      case 4:
        return  "bg-green-500";
      case 5:
        return "bg-gray-500" ;
        case 6:
          return "bg-red-500";
      case 7:
        return "bg-purple-500";
    default:
      return "";
  }
};

export const getTimeFormat = (dateString) => {
  
  const date = new Date(dateString);

  // Get hours, minutes, and seconds
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  const result = hours + ':' + minutes + ':' + seconds;

  return result;
}

export const defaultCountryProperties = [
  // { code: "us", name: "USA", flag: "/img/usa_flag.png", actived: false },
  { code: "pa", name: "PANAMÁ", flag: "/img/pa_flag.png", actived: true },
  { code: "br", name: "BRASIL", flag: "/img/br_flag.png", actived: true },
];

export const findActionsByPath = (data, path) => {

  const searchOptions = (options) => {
    for (const option of options) {
        if (option.path === path && option.actions) {
            return option.actions;
        } else if (option.subNav && option.subNav.length > 0) {
            const actions = searchOptions(option.subNav);
            if (actions.length > 0) {
                return actions;
            }
        }
    }
    return [];
}

return searchOptions(data.options);
  }

  export  const getIconStatusClients = (id) => {
    switch (id) {
      case 1:
        return <FaCircleCheck />;
      case 2:
        return <FaTimesCircle />;
      case 3:
        return <FaRegClock />;
      default:
        return "";
    }
  };

  export const getColorStatusClient = (id) => {
    switch (id) {
      case 1:
        return "success";
      case 2:
        return "alert";
      case 3:
        return "warning";
      default:
        return "";
  }
}

  export  const getNameStatusClients = (id) => {
    switch (id) {
      case 1:
        return  translate("global.state.active");
      case 2:
        return translate("global.state.inactive");
      case 3:
        return translate("global.pendingActive");
      default:
        return "";
    }
  };


  
  export  const getLabelTipoCliente = (id) => {
    switch (id) {
      case 1:
        return <span className="badge-status font-semibold m-0"><BiPackage className="mr-1" size={18}/>{translate("global.package")}</span>;
      case 7:
        return <span className="badge-status fucsia font-semibold m-0"><FaRegBuilding className="mr-1" size={16}/> {translate("global.BLI")}</span>;
      default:
        return "";
    }
  };

  export  const getLabelTipoClienteUS = (item) => {
    const user = item;
    const Company = user?.CompanyName;
    const typeClient = user?.IdTipoCliente;

    switch (typeClient) {
      case 1:
        return <span className="badge-status font-semibold m-0"><PiLockers className="mr-1" size={18}/>{Company}</span>;
      case 7:
        return <span className="badge-status fucsia font-semibold m-0"><FaRegBuilding className="mr-1" size={16}/> {Company}</span>;
      default:
        return "";
    }
  };

  export const getNameRoleBli = (id) => {
    switch (id) {
      case 1:
        return translate("global.typesRoleBli.1");
        case 2:
        return translate("global.typesRoleBli.2");
        case 3:
          return translate("global.typesRoleBli.3");
        case 4:
          return translate("global.typesRoleBli.4");
          case 5:
            return translate("global.typesRoleBli.5");
            case 6:
              return translate("global.typesRoleBli.6");
              case 7:
          return translate("global.typesRoleBli.7");
      default:
        return "";
    }
  };

  export  const getNameTipoPlanCliente = (id) => {
    switch (id) {
      case 1:
        return translate("global.status.typePlanClient.normalBasic");
      case 2:
        return translate("global.status.typePlanClient.normalPremium");
      case 3:
        return translate("global.status.typePlanClient.basicBusiness");
        case 4:
          return translate("global.status.typePlanClient.premiumBusiness");
          case 5:
          return translate("global.status.typePlanClient.boxitStore");
          case 6:
          return translate("global.status.typePlanClient.vip");
          case 7:
          return translate("global.status.typePlanClient.preferential");
      default:
        return "";
    }
  };

  
export const groupDoors = async (doorArray) => {
    if (doorArray?.length === 0) return [];
    const groupedDoors = {};
    doorArray?.forEach(door => {
        const key = `${door.boxitDoorId}`;
        if (!groupedDoors[key]) {
            groupedDoors[key] = {
                locationId: door.locationId,
                moduleId: door.moduleId,
                boxitLocationId: door.boxitLocationId,
                boxitModuleId: door.boxitModuleId,
                boxitDoorId: door.boxitDoorId,
                doorNumber: door.doorNumber,
                dimension: door.dimension,
                comPort: door.comPort,
                createdAt: door.createdAt,
                doorSequence: door.doorSequence,
                isActive: door.isActive,
                isAvailable: door.isAvailable,
                isScreen: door.isScreen,
                columnModule: door.columnModule,
                layer: door.layer,
                packageStatusId: door.packageStatusId,
                moduleNumber: Number(door.moduleNumber),
                packages: []
            };
        }
        if (groupedDoors[key].packages.length > 0 || door.packageId) {
            groupedDoors[key].packages.push({
                packageId: door.packageId,
                packageNumber: door.packageNumber,
            });
        }
    });

    const groupedDoorsArray = Object.values(groupedDoors);

    // Ordenamos por moduleNumber y luego por doorNumber
    const doorsOrdenate = groupedDoorsArray.sort((a, b) => {
        // Comparar por moduleNumber
        if (a.moduleNumber !== b.moduleNumber) {
            return a.moduleNumber - b.moduleNumber;
        }
        // Si moduleNumber es igual, comparar por doorNumber (conversión a número para evitar problemas)
        return Number(a.doorNumber) - Number(b.doorNumber);
    });

    return doorsOrdenate;
};

export const hoursIn24And12Format = [
  {id: '00:00', value: '12:00 am'},
  {id: '01:00', value: '1:00 am'},
  {id: '02:00', value: '2:00 am'},
  {id: '03:00', value: '3:00 am'},
  {id: '04:00', value: '4:00 am'},
  {id: '05:00', value: '5:00 am'},
  {id: '06:00', value: '6:00 am'},
  {id: '07:00', value: '7:00 am'},
  {id: '08:00', value: '8:00 am'},
  {id: '09:00', value: '9:00 am'},
  {id: '10:00', value: '10:00 am'},
  {id: '11:00', value: '11:00 am'},
  {id: '12:00', value: '12:00 pm'},
  {id: '13:00', value: '1:00 pm'},
  {id: '14:00', value: '2:00 pm'},
  {id: '15:00', value: '3:00 pm'},
  {id: '16:00', value: '4:00 pm'},
  {id: '17:00', value: '5:00 pm'},
  {id: '18:00', value: '6:00 pm'},
  {id: '19:00', value: '7:00 pm'},
  {id: '20:00', value: '8:00 pm'},
  {id: '21:00', value: '9:00 pm'},
  {id: '22:00', value: '10:00 pm'},
  {id: '23:00', value: '11:00 pm'}
];

export const getConditionValue = (value) => {
  switch (value) {
    case true:
      return "1";
    case false:
      return "0";
    case "1":
      return true;
      case "0":
        return false;
      case "false":
        return 0;
      case "true":
        return 1;

    default:
      return '';
  }
  };

  export const formatNumberCharts = (value) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)}k`;
    }
    return value.toString();
  };

  export  const getColorStatusPackages = (id) => {
    switch (id) {
      case 1:
        return "bg-blue-500";
      case 2:
        return "bg-yellow-500";
      case 3:
        return "bg-orange-500";
        case 4:
          return  "bg-green-500";
        case 5:
          return "bg-gray-500" ;
          case 6:
            return "bg-red-500";
      case 7:
        return "bg-purple-500";
      default:
        return "";
    }
  };

  const packageStatusProperties = {
    1: { 
      bg: "bg-blue-500", 
      color: "#3b82f6", 
      text: "global.status.new", 
      icon: <FaBoxOpen /> 
    },
    2: { 
      bg: "bg-yellow-500", 
      color: "#f59e0b", 
      text: "global.status.reservedDoor", 
      icon: <FaDoorOpen /> 
    },
    3: { 
      bg: "bg-orange-500", 
      color: "#f97316", 
      text: "global.status.inBoxit", 
      icon: <PiLockersFill /> 
    },
    4: { 
      bg: "bg-green-500", 
      color: "#10b981", 
      text: "global.status.retired", 
      icon: <FaCheckCircle /> 
    },
    5: { 
      bg: "bg-gray-500", 
      color: "#6b7280", 
      text: "global.status.returned", 
      icon: <FaUndo /> 
    },
    6: { 
      bg: "bg-red-500", 
      color: "#ef4444", 
      text: "global.status.annulled", 
      icon: <FaTimesCircle /> 
    },
    7: { 
      bg: "bg-purple-500", 
      color: "#a855f7", 
      text: "global.status.inTransit", 
      icon: <FaTruck /> 
    },
  };

const PACKAGE_TYPES_BY_COUNTRY = {
  US: {
    0: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    1: { text: "global.status.typePackage.returned", icon: <FaUndo />, color: "#4abfee", bg: "#ebf9ff" },
  },
  PA: {
    0: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    1: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    2: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    3: { text: "global.status.typePackage.returned", icon: <FaUndo />, color: "#4abfee", bg: "#ebf9ff" },
  },
  BR: {
    0: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    1: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    2: { text: "global.status.typePackage.regular", icon: <FaBox />, color: "#d76a14", bg: "#fef1e6" },
    3: { text: "global.status.typePackage.returned", icon: <FaUndo />, color: "#4abfee", bg: "#ebf9ff" },
  }
};

const getCurrentCountry = () => {
  const raw = localStorage.getItem("country"); 
  return (raw || "us").toUpperCase(); 
};

export const getPropsTypeOfPackage = (id) => {
  const idNormalized = Number(id);
  const country = getCurrentCountry();
  const typesForCountry = PACKAGE_TYPES_BY_COUNTRY[country] ?? PACKAGE_TYPES_BY_COUNTRY.US;
  return typesForCountry[idNormalized] ?? typesForCountry[0];
};

/**
 * Info de tipo de paquete considerando Drop Off. Un Drop Off (IsDropoff = true Y
 * IdTipoPaquete = 1, solo USA) se muestra como "Drop Off" en lugar del tipo estándar,
 * consistente con el badge de la tabla y con el SP UspFindTrackingPaquetes.
 */
export const getPackageTypeInfo = (item) => {
  const idTipo = Number(item?.IdTipoPaquete ?? 1);
  if (item?.IsDropoff && idTipo === 1) {
    return {
      text: "global.status.typePackage.dropoff",
      icon: <FaBoxOpen />,
      color: "#4abfee",
      bg: "#ebf9ff",
    };
  }
  return getPropsTypeOfPackage(idTipo);
};

/**
 * Opciones de filtro por tipo de paquete según país.
 * USA: 0=Pick up, 1=Return
 * Panama/BR: 0,1,2=Pick up, 3=Return
 */
export const getPackageTypeFilterOptions = () => {
  const country = getCurrentCountry();
  const isUS = country === 'US';
  return isUS
    ? [
        { id: '0', label: 'global.status.typePackage.regular', value: '0', iconKey: 'regular' },
        { id: '1', label: 'global.status.typePackage.returned', value: '1', iconKey: 'returned' },
        { id: 'dropoff', label: 'global.status.typePackage.dropoff', value: 'dropoff', iconKey: 'dropoff' }
      ]
    : [
        { id: 'pickup', label: 'global.status.typePackage.regular', value: '0,1,2', iconKey: 'regular' },
        { id: 'return', label: 'global.status.typePackage.returned', value: '3', iconKey: 'returned' }
      ];
};

export const renderTypePackage = (item) => {
  const id = item?.IdTipoPaquete ?? 1;   
  const {text, icon, color, bg } = getPropsTypeOfPackage(id);    
  
        return <span  style={{ color: color, padding:"4px 6px", borderRadius:"15px", background: bg}}><span className="mr-1">{icon && icon}</span>{ text ? translate(text) : "" }</span>
};
  

  export const getPropertyPackagesStatus = (id) => {
    const status = packageStatusProperties[id];
    return status ? { ...status, text: translate(status.text, "capital") } : "";
  };

  /**
   * Etiqueta de estado en ficha de paquete: si es tipo devolución (return) y está retirado (4),
   * se muestra "Collected" / i18n `global.returned`; en caso contrario el texto estándar del estado.
   */
  export const getPackageDetailStatusLabel = (idEstatus, idTipoPaquete) => {
    const statusInfo = idEstatus != null ? getPropertyPackagesStatus(idEstatus) : null;
    if (!statusInfo || typeof statusInfo !== "object") return "";
    const idTipo = idTipoPaquete ?? 1;
    const typeInfo = getPropsTypeOfPackage(idTipo);
    const isReturnType = typeInfo?.text === "global.status.typePackage.returned";
    if (Number(idEstatus) === 4 && isReturnType) {
      return translate("global.returned", "capital");
    }
    return statusInfo.text;
  };


  export const exportToExcelCustome = (fileName, sheetName, columns, rows) => {
    const worksheetData = [
      columns.map(col => col.title.toUpperCase()) // Títulos en MAYÚSCULA
    ].concat(
      rows.map(row => columns.map(col => row[col.dataKey]))
    );
  
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
    // Definir el rango
    const range = XLSX.utils.decode_range(worksheet['!ref']);
  
    // Activar autofiltro (esto es básico, igual lo dejamos)
    worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(range) };
  
    // Crear tabla estructurada
    worksheet['!tables'] = [{
      name: "Table1",
      ref: XLSX.utils.encode_cell({ r: 0, c: 0 }),
      ref_end: XLSX.utils.encode_cell({ r: range.e.r, c: range.e.c }),
      headerRow: true,
      totalsRow: false,
      columns: columns.map(col => ({ name: col.title.toUpperCase(), filterButton: true })),
      style: {
        theme: "TableStyleMedium2", // Puedes cambiar el estilo aquí
        showRowStripes: true,
      }
    }];
  
    // Ajustar ancho de columnas automáticamente
    worksheet['!cols'] = columns.map((col, index) => {
      const max_length = Math.max(
        col.title.length,
        ...rows.map(row => (row[col.dataKey]?.toString()?.length || 0))
      );
      return { wch: max_length + 5 };
    });
  
    // Aplicar estilos personalizados a los headers (primera fila)
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { patternType: "solid", fgColor: { rgb: "D1C4E9" } },
        alignment: { horizontal: "center", vertical: "center" }
      };
    }
  
    // Crear el libro y exportar
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true
    });
  
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, `${fileName}.xlsx`);
  };

  export const exportToExcelGeneral = (fileName, sheetName, data) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const keys = Object.keys(data[0]);

  const worksheetData = [
    keys.map(k => k.toUpperCase())
  ].concat(
    data.map(row => keys.map(k => row[k]))
  );

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const range = XLSX.utils.decode_range(worksheet['!ref']);

  worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(range) };

  worksheet['!tables'] = [{
    name: "Table1",
    ref: XLSX.utils.encode_cell({ r: 0, c: 0 }),
    ref_end: XLSX.utils.encode_cell({ r: range.e.r, c: range.e.c }),
    headerRow: true,
    totalsRow: false,
    columns: keys.map(k => ({ name: k.toUpperCase(), filterButton: true })),
    style: {
      theme: "TableStyleMedium2",
      showRowStripes: true,
    }
  }];

  worksheet['!cols'] = keys.map(key => {
    const maxLength = Math.max(
      key.length,
      ...data.map(row => (row[key]?.toString().length || 0))
    );
    return { wch: maxLength + 5 };
  });

  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    if (!worksheet[cellAddress]) continue;
    worksheet[cellAddress].s = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { patternType: "solid", fgColor: { rgb: "D1C4E9" } },
      alignment: { horizontal: "center", vertical: "center" }
    };
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
    cellStyles: true
  });

  const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(dataBlob, `${fileName}.xlsx`);
};


      // obtener la clasificacion
      export const handlerGetClasificacion = dimension => {
          switch (dimension) {
              case 'S':
                  return 'P';
              case 'M':
                  return 'M';
              case 'L':
                  return 'G';
              case 'XL':
                  return 'XG'
  
              // CASE ALTERNATIVE
              case 'A':
                  return 'P';
              case 'B':
                  return 'M';
              case 'C':
                  return 'G';
              case 'D':
                  return 'XG'
  
              default:
                  break;
          }
      }
  // P, M, G, XG - DAshboard - S, M, L, XL - DB

  /**
 * Maneja el almacenamiento en localStorage o sessionStorage.
 * 
 * @param {'get' | 'set'} action - Acción a realizar: 'get' o 'set'.
 * @param {'local' | 'session'} storageType - Tipo de almacenamiento: 'local' o 'session'.
 * @param {string} key - Clave del ítem.
 * @param {any} [value] - Valor a guardar (solo necesario para 'set').
 * @returns {any} - Valor recuperado (si action es 'get').
 */
export const handleStorage = (action, storageType, key, value) => {
  const storage = storageType === 'local' ? localStorage : sessionStorage;
  
  if (action === 'set') {
    storage.setItem(key, JSON.stringify(value));
  } else if (action === 'get') {
    const item = storage.getItem(key);
    
    try {      
      return JSON.parse(item);
    } catch {
      return item;
    }
  }
};

   export const getTerminosCondiciones  =  async () =>  {
         // Abrir nueva pestaña (puede ser una página de confirmación)
  window.open('https://public.myboxit.com/TerminosCondiciones-BoxitLogisticaInteligente.pdf', '_blank');

  // También forzar la descarga
  const response = await fetch('https://public.myboxit.com/TerminosCondiciones-BoxitLogisticaInteligente.pdf');
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = 'TerminosCondiciones-BoxitLogisticaInteligente.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
    }
